/**
 * Created by yniran on 23/12/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
//        BaseModel = require("models/BaseModel"),
        SurveyQuestionModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        SurveyQuestionModel = Backbone.Model.extend({
            name: "SurveyQuestionModel",
            defaults: {
            },

            getAnswers: function () {
                return this.collection.getQuestionAnswers(this);
            },

            setAnswer: function (value, validate) {
                this.collection.submitAnswer(this, value);
                this.set("value", value, {validate: validate});
            },

            validate: function () {
                var isValid = this.collection.isValidAnswer(this);

                return !isValid;
            },

            isValid: function(options){//i just want the good ol' backbone isValid function ! :(
                return this.isValidAttr(options); //LE FW overrides the backbone model isValid function without leaving a way to call it :( except with the inappropriately named "isValidAttr" method
            }
        });
    });

    return SurveyQuestionModel;
});
